





















































































import Component from 'vue-class-component'
import Vue from 'vue'

import { TextFieldRules } from '@/utils/enums'
import authModule from '@/store/auth'
import MessageAlert from '@/components/MessageAlert.vue'
import OptionalSettingsDialog from '@/components/user/OptionalSettingsDialog.vue'

@Component({
  name: 'RegisterView',
  components: {
    MessageAlert,
    OptionalSettingsDialog
  }
})
class RegisterView extends Vue {
  private isFormValid = false
  private showOptionals = false
  private rules = TextFieldRules
  private passwordConfirm = ''
  private form = {
    firstName: '',
    email: '',
    password: ''
  }

  private registerWithOptionals(optionalsForm: any): void {
    Object.assign(this.form, optionalsForm)
    this.register()
  }

  private async register(): Promise<void> {
    await authModule.register(this.form)
    if (authModule.user && authModule.user.categories.length === 0) {
      this.$router.replace({ name: 'Interests' })
    } else if (authModule.user) {
      this.$router.replace({ name: 'HomeView' })
    }
  }
}

export default RegisterView
